<div class="container-fluid">
    <div class="row m-2">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <div class="row pt-3 pb-3">
        <div class="col">
            <h2>Create Location</h2>
        </div>
    </div>
    <form class="mb-2" [formGroup]="form" (ngSubmit)="onSubmit(form)">
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <input matInput type="text" id="displayName" name="displayName" placeholder="Name"
                        formControlName="displayName">
                    <mat-error *ngIf="form.get('displayName').errors?.required">Name is required</mat-error>
                    <mat-error *ngIf="form.get('displayName').errors?.validationErrors">
                        {{ form.get("displayName").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <input matInput type="text" id="address1" name="address1" placeholder="Address 1"
                        formControlName="address1">
                    <mat-error *ngIf="form.get('address1').errors?.required">Address 1 is required</mat-error>
                    <mat-error *ngIf="form.get('address1').errors?.validationErrors">
                        {{ form.get("address1").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <input matInput type="address2" id="address2" name="address2" placeholder="Address 2"
                        formControlName="address2">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <input matInput type="text" id="city" name="city" placeholder="City" formControlName="city">
                    <mat-error *ngIf="form.get('city').errors?.required">City is required</mat-error>
                    <mat-error *ngIf="form.get('city').errors?.validationErrors">
                        {{ form.get("city").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <mat-select formControlName="state" name="state" placeholder="State">
                        @for (state of allStates; track state) {
                          <mat-option [value]="state.abbreviation">{{state.name}}</mat-option>
                        }
                      </mat-select>
                    <mat-error *ngIf="form.get('state').errors?.required">State is required</mat-error>
                    <mat-error *ngIf="form.get('state').errors?.validationErrors">
                        {{ form.get("state").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field>
                    <input matInput type="text" id="postalCode" name="postalCode" placeholder="Zip" formControlName="postalCode">
                    <mat-error *ngIf="form.get('postalCode').errors?.required">Zip is required</mat-error>
                    <mat-error *ngIf="form.get('postalCode').errors?.validationErrors">
                        {{ form.get("postalCode").errors?.validationErrors}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <button mat-raised-button class="button-spacing" [disabled]="isLoading" type="submit">
                    Save
                </button>
            </div>
            <div class="col">
                <button type="button" mat-raised-button (click)="dialogRef.close({status: 'cancel', message: 'Cancelled adding terminal location'})" [disabled]="isLoading">
                    Cancel
                </button>
            </div>
        </div>
    </form>
</div>